const DieuKhoanChungPage = () => {
  return (
    <div className="container chinh-sach mt-6">
      <div className="chinh-sach-bao-mat list-chinhsach px-4">
        <h4 className="text-center text-uppercase">Điều Khoản Chung</h4>
        <blockquote className="mb-3">
          <p>1. Giới thiệu</p>
        </blockquote>
        <p className="mb-2">
          Chào mừng Quý khách hàng đến với{" "}
          <a href="https://gigacare.vn/homepage">
            https://gigacare.vn/homepage
          </a>
          , do Hợp Long sở hữu và vận hành. Trước khi truy cập hoặc sử dụng
          trang web của chúng tôi, vui lòng đọc kỹ các Điều kiện và điều khoản
          chung (sau đây gọi tắt là Điều khoản) và đảm bảo đã hiểu rõ những điều
          khoản này, bao gồm tuyên bố miễn trừ và giới hạn trách nhiệm pháp lý.
        </p>
        <p className="mb-2">
          Bằng việc truy cập và/hoặc sử dụng trang web có địa chỉ
          <a href="https://gigacare.vn/homepage">
            https://gigacare.vn/homepage
          </a>{" "}
          (sau đây gọi tắt là Webstite), Quý khách đã chấp nhận và đồng ý tuân
          thủ các Điều kiện và điều khoản chung sau đây, cùng với bất kỳ điều
          khoản hoặc quy định pháp luật khác đăng tải trên Website, như Chính
          sách bảo mật, quy định về quan hệ giữa người sử dụng là Quý khách với
          Gigacare trong các vấn đề liên quan tới Website.
        </p>
        <p>
          Thuật ngữ “Gigacare”, “chúng tôi” hoặc “của chúng tôi” nghĩa là Hợp
          Long. Thuật ngữ “Quý khách hàng”, “khách hàng”, “Quý khách” nghĩa là
          người dùng hoặc người xem trang web của chúng tôi.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>2. Tính đủ điều kiện</p>
        </blockquote>
        <p className="mb-2">
          2.1 Website của chúng tôi chỉ phục vụ những người cư trú tại Việt Nam.
          Chúng tôi không chấp nhận hoặc xử lý đơn đặt hàng từ các cá nhân ở bên
          ngoài lãnh thổ Việt Nam.
        </p>
        <p>
          2.2 Website không hướng đến hoặc được thiết kế để sử dụng bởi bất kỳ
          ai dưới 18 tuổi. Khách hàng cam kết và đảm bảo rằng mình từ 18 tuổi
          trở lên hoặc đang truy cập Website dưới sự giám sát của cha mẹ hoặc
          người giám hộ, những người chịu trách nhiệm ràng buộc bởi các Điều
          khoản này.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>3. Pháp luật và các quy định</p>
        </blockquote>
        <p>
          Việc truy cập và sử dụng Website của Quý khách sẽ được điều chỉnh và
          giải thích theo pháp luật hiện hành của nước Cộng hòa xã hội chủ nghĩa
          Việt Nam, mà không tham chiếu đến các quy tắc xung đột pháp luật. Quý
          khách đồng ý chấp nhận thẩm quyền xét xử tối cao của Tòa án nước Cộng
          hòa xã hội chủ nghĩa Việt Nam.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>4. Bản quyền, nhãn hiệu và quyền sở hữu trí tuệ</p>
        </blockquote>
        <p className="mb-2">
          4.1 Các thương hiệu, logo và nhãn hiệu dịch vụ (sau đây gọi chung là
          Nhãn hiệu), cùng với toàn bộ nội dung (bao gồm nhưng không giới hạn ở
          thông tin, truyền thông, phần mềm, hình ảnh, video và âm thanh) (sau
          đây gọi chung là Nội dung) có sẵn trên Website thuộc quyền sở hữu của
          Hợp Long, các nhà cung cấp nội dung và các bên cấp phép liên quan. Quý
          khách phải thừa nhận rằng tất cả Nhãn hiệu và Nội dung trên Website
          đều được bảo vệ bởi luật bản quyền và các luật sở hữu trí tuệ hiện
          hành, trừ khi có quy định hoặc thông báo khác.
        </p>

        <p className="mb-2">
          4.2 Quý khách bị nghiêm cấm sao chép, sửa đổi, chuyển nhượng, phân
          phối, tái xuất bản, tải về, gửi hoặc truyền tải Nhãn hiệu và Nội dung
          dưới bất kỳ hình thức hoặc bằng bất kỳ phương tiện nào (bao gồm nhưng
          không giới hạn ở phương tiện điện tử, sao chép cơ học hoặc ghi âm) mà
          chưa có sự cho phép trước bằng văn bản của Hợp Long. Quý khách đồng ý
          rằng các Nhãn hiệu và Nội dung trên Website không được phép sử dụng
          cho bất kỳ mục đích hoặc phân phối thương mại nào. Việc sử dụng trái
          phép Nhãn hiệu hoặc Nội dung có thể dẫn đến vi phạm luật bản quyền,
          luật thương hiệu, luật bảo mật và công khai, cùng các đạo luật dân sự
          và hình sự hiện hành.Hợp Long bảo lưu mọi quyền liên quan.
        </p>

        <br />
        <blockquote className="mb-3">
          <p>5. Hành vi của quý khách hàng</p>
        </blockquote>
        <p>
          Quý khách không được phép đăng tải hoặc truyền tải bất kỳ tài liệu nào
          mang tính chất phản loạn, đe dọa, phỉ báng, bôi nhọ, tục tĩu, khiêu
          dâm, xúc phạm hoặc tài liệu trái pháp luật hoặc bất kỳ tài liệu có thể
          cấu thành hoặc khuyến khích hành vi được coi là một hành vi phạm tội
          hình sự hoặc làm phát sinh trách nhiệm dân sự, hoặc vi phạm bất kỳ
          điều luật hiện hành nào. Gigacare sẽ hợp tác đầy đủ với các cơ quan
          thực thi pháp luật hoặc lệnh của tòa án yêu cầu tiết lộ danh tính của
          bất cứ ai đăng tải các tài liệu kể trên.
        </p>
        <br />
        <br />
        <blockquote className="mb-3">
          <p>6. Liên kết</p>
        </blockquote>
        <p className="mb-2">
          6.1 Website có thể cung cấp các liên kết đến các trang web khác do bên
          thứ ba quản lý (sau đây gọi là Trang liên kết). Gigacare không có
          nghĩa vụ giám sát, thay đổi, cập nhật hoặc kiểm soát nội dung trên các
          Trang liên kết này. Việc cung cấp liên kết đến các trang web của bên
          thứ ba không cấu thành sự chứng thực, ủy quyền, tài trợ hoặc bất kỳ sự
          sáp nhập nào với các trang web đó, chủ sở hữu hoặc các nhà cung cấp
          dịch vụ của họ.
        </p>
        <p className="mb-2">
          6.2 Các Trang liên kết có thể áp dụng các quy định riêng về chính sách
          quyền riêng tư, điều khoản bảo mật, điều khoản truyền tải thông tin cá
          nhân và các điều khoản sử dụng khác, vốn không nhất thiết trùng khớp
          với Chính sách bảo mật của chúng tôi. Nếu Quý khách truy cập các liên
          kết này, vui lòng xem xét kỹ các điều khoản sử dụng, chính sách bảo
          mật và thông báo tương ứng của từng trang.
        </p>

        <br />
        <blockquote className="mb-3">
          <p>7. Tuyên bố miễn trừ trách nhiệm</p>
        </blockquote>
        <p className="mb-2">
          7.1 Tất cả Nội dung trên Website được cung cấp cho Quý khách trên cơ
          sở “nguyên trạng” và “có sẵn”, mà không kèm theo bất kỳ sự đảm bảo nào
          dù rõ ràng hay ngụ ý. Các đảm bảo này bao gồm, nhưng không giới hạn
          bởi, các đảm bảo ngụ ý về khả năng bán được, sự phù hợp cho một mục
          đích cụ thể, quyền sở hữu, tính không vi phạm, tính bảo mật, hoặc tính
          chính xác. Gigacare đặc biệt từ chối bất kỳ trách nhiệm nào đối với
          bất kỳ lỗi hoặc thiếu sót nào trong Nội dung. Gigacare hoặc bất kỳ bên
          nào khác tham gia vào việc tạo ra, sản xuất, hoặc cung cấp Website sẽ
          không chịu trách nhiệm về bất kỳ thiệt hại hoặc khoản phạt nào (dù là
          trực tiếp, gián tiếp, hay ngẫu nhiên) phát sinh từ việc Quý khách truy
          cập, sử dụng, hoặc không có khả năng truy cập, sử dụng Website.
        </p>
        <p className="mb-2">
          7.2 Bất kỳ Nội dung nào được tải về, tải lên hoặc thu thập được thông
          qua việc sử dụng Website đều hoàn toàn do Quý khách tự quyết định và
          chịu rủi ro. Trách nhiệm đánh giá tính chính xác, đầy đủ và hữu ích
          của tất cả các ý kiến, tư vấn, dịch vụ, hàng hóa và các thông tin khác
          được cung cấp thông qua Website hoặc trên Internet nói chung thuộc về
          Quý khách một cách tuyệt đối.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>8. Giới hạn trách nhiệm pháp lý</p>
        </blockquote>
        <p className="mb-2">
          Nội dung Website hoặc một trang liên kết có thể không chính xác hoặc
          lỗi đánh máy, và chúng tôi từ chối bất cứ trách nhiệm cho sự thiếu
          chính xác hoặc sai sót này. Chúng tôi không cam kết hay bảo đảm rằng
          các nội dung trên trang web là hoàn chỉnh hoặc cập nhật và không có
          nghĩa vụ phải cập nhật các nội dung trên trang web. Chúng tôi có thể
          cải thiện hoặc thay đổi các trang web và nội dung bất cứ lúc nào mà
          không cần thông báo.
        </p>
        <p className="mb-2">
          Quý khách đồng ý rằng Gigacare và bất kỳ nhân viên liên quan, giám đốc
          hoặc các đại lý sẽ không chịu trách nhiệm, kể cả trong hợp đồng hay do
          sai sót cá nhân, đối với bất kỳ thiệt hại hay trừng phạt trực tiếp,
          gián tiếp, đặc biệt hoặc ngẫu nhiên (bao gồm nhưng không hạn chế bởi
          thua lỗ, chi phí mua sắm dịch vụ thay thế hoặc mất cơ hội) phát sinh
          từ hoặc có liên quan đến việc sử dụng Website hoặc một trang liên kết,
          chậm trễ hoặc không thể sử dụng Website hoặc một trang liên kết, ngay
          cả khi chúng tôi được nhận thức được khả năng xảy ra thiệt hại.
        </p>
        <p className="mb-2">
          Giới hạn trách nhiệm này bao gồm, nhưng không giới hạn ở việc truyền
          tải bất kỳ loại virus có thể lây nhiễm thiết bị của Quý khách, sự cố
          hư hỏng thiết bị cơ khí hoặc điện tử hoặc đường dây thông tin liên lạc
          hư hỏng, điện thoại hoặc các vấn đề kết nối khác như không có khả năng
          truy cập vào nhà cung cấp dịch vụ internet của Quý khách, truy cập
          trái phép , trộm cắp, lỗi hệ điều hành, đình công, các vấn đề lao động
          khác hoặc bất kỳ trường hợp bất khả kháng nào. Dù chúng tôi đã nỗ lực
          hết khả năng để đảm bảo an ninh và bảo trì Website, chúng tôi không
          thể và không đảm bảo việc truy cập liên tục, không bị gián đoạn hoặc
          an toàn vào Website.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>9. CHUYỂN GIAO THÔNG TIN CÁ NHÂN</p>
        </blockquote>
        <p className="mb-2">
          Quý khách đã đọc và hiểu rõ Chính sách bảo mật của chúng tôi, trong đó
          quy định chi tiết về việc thu thập, sử dụng, lưu giữ và tiết lộ dữ
          liệu cá nhân của Quý khách. Theo đó, Quý khách đã đồng ý với các điều
          khoản bảo mật thông tin của chúng tôi và cho phép chúng tôi thu thập
          và chuyển giao dữ liệu cá nhân của Quý khách theo các điều khoản trong
          Chính sách bảo mật của chúng tôi.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>10. Bảo mật thông tin liên lạc với khách hàng</p>
        </blockquote>
        <p className="mb-2">
          Trừ trường hợp được quy định trong pháp luật hiện hành và Chính sách
          bảo mật của Gigacare, bất kỳ thông tin hoặc tài liệu nào Quý khách gửi
          đến Website bằng thư điện tử, thư bưu điện hay phương thức tương đương
          (bao gồm cả dữ liệu, câu hỏi, ý kiến, đề nghị hay các nội dung tương
          tự) sẽ được coi là thông tin không bảo mật và không độc quyền.
        </p>
        <p className="mb-2">
          Chúng tôi có quyền tự do sử dụng các thông tin này cho bất kỳ mục đích
          nào, bao gồm nhưng không giới hạn bởi sao chép, tiết lộ, truyền dẫn,
          xuất bản, phát sóng và gửi thư, mà không phải chịu trách nhiệm bồi
          thường cho Quý khách.
        </p>
        <p className="mb-2">
          Chúng tôi sẽ không chịu trách nhiệm cho bất kỳ sự can thiệp trái phép
          hoặc trái pháp luật nào vào thông tin liên lạc giữa Quý khách và chúng
          tôi (dù bằng thư điện tử hay phương thức khác), cũng như cho bất kỳ
          tổn thất hoặc thiệt hại nào phát sinh (bao gồm nhưng không giới hạn
          bởi tổn thất hoặc thiệt hại phát sinh từ việc sử dụng trái phép hoặc
          gian lận thông tin có trong hoặc truy cập thông qua liên lạc).
        </p>
        <br />
        <blockquote className="mb-3">
          <p>11. Điều khoản chung</p>
        </blockquote>
        <p className="mb-2">
          11.1 Điều kiện và điều khoản chung nào được xác định là không hợp lệ
          hoặc không thể có hiệu lực thì điều khoản không hợp lệ hoặc không thể
          có hiệu lực đó sẽ được thay thế bởi một hoặc nhiều điều khoản hợp lệ,
          khả thi phù hợp nhất với điều khoản cũ và phần còn lại của Điều kiện
          và điều khoản chung tiếp tục có hiệu lực.
        </p>
        <p className="mb-2">
          11.2 Việc Gigacare không yêu cầu hoặc không thực thi nghiêm ngặt bất
          kỳ quy định nào trong Điều khoản và Điều kiện chung này sẽ không được
          diễn giải là từ bỏ bất kỳ điều khoản hay quyền lợi nào của chúng tôi
          trong tương lai.
        </p>
        <p className="mb-2">
          11.3 Chúng tôi bảo lưu quyền thay đổi hoặc sửa đổi các Điều kiện và
          điều khoản chung hoặc bất kỳ chính sách nào khác liên quan đến việc sử
          dụng trang web của chúng tôi vào bất cứ thời điểm nào, theo quyết định
          riêng của chúng tôi, bằng cách đăng tải các sửa đổi trên Website. Việc
          Quý khách tiếp tục sử dụng Website sau khi các thay đổi hoặc sửa đổi
          này được đăng tải sẽ được xem là Quý khách đã chấp nhận hoàn toàn
          những thay đổi hoặc sửa đổi đó.
        </p>
        <br />
        <blockquote className="mb-3">
          <p>12. LIÊN HỆ</p>
        </blockquote>
        <p className="mb-2">
          Nếu Quý khách hàng có bất kỳ câu hỏi hoặc lo ngại nào về các Điều
          khoản sử dụng này, vui lòng liên hệ với chúng tôi qua Email:
          cs@hoplong.com
        </p>
      </div>
    </div>
  );
};

export default DieuKhoanChungPage;
